import React from 'react';
export function EmojiIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.4a8 8 0 014.941-.018 1 1 0 10.61-1.905A10 10 0 1022 12a1 1 0 10-2 0A8 8 0 119.5 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6a1 1 0 100 2h2v2a1 1 0 102 0V8h2a1 1 0 100-2h-2V4a1 1 0 10-2 0v2h-2zM7.518 11.909a1 1 0 10-1.991.182 6.5 6.5 0 0012.726 1.182 1 1 0 10-1.924-.546 4.511 4.511 0 01-1.147 1.955 4.498 4.498 0 01-6.364 0 4.5 4.5 0 01-1.3-2.773z"
  }));
}